export function valuesFromString(rentString) {
    let rentRegex = /\$\d+(?:\.\d{1,2})?/g;
    let match = rentString.match(rentRegex);

    if (!match) {
        return [];
    }

    let parsed = match.map((s) => parseFloat(s.slice(1))).filter(Boolean);

    if (!parsed.length) {
        return [];
    }

    parsed.sort(function(a, b) {
        return a - b;
    });

    return [parsed[0], parsed[parsed.length-1]];
}

function matchAll(regex, str) {
    var match;
    let results = [];

    while ((match = regex.exec(str)) != null) {
        results.push(match[0]);
    }

    return results;
}
